import { bootBlock, claim, listenWhileConnected } from '../../src/js/blockRuntime';

// One state object per block instance (the editor canvas can hold several instances and re-renders them).
const createBlogPostsPaginationAjax = (root) => {
  const blogPostsPaginationAjax = {
    settings: {
        filter: '',
        postsNumber: 0,
        offset: 0,
    },
    init: function(owner) {
        this.categoryChangeHandler();
        this.changePageWithPageNumberButtonHandler(owner);
        this.checkHash();
        this.changePageHandler(owner);

        listenWhileConnected(window, 'hashchange', () => {
          this.checkHash();
        }, owner);
    },

    changePageHandler: (owner) => {
        // Use event delegation on a parent container that exists on page load
        listenWhileConnected(root, 'click', (e) => {
            // Check if the clicked element or its parent matches our pagination arrows
            const targetButton = e.target.closest('.blog-posts-pagination__pagination-prev, .blog-posts-pagination__pagination-next');
            if (targetButton) {
                const arrowDirection = targetButton.getAttribute('data-nav');
                const currentPage = blogPostsPaginationAjax.getActivePage();

                if (arrowDirection === 'prev') {
                    if (currentPage > 1) {
                        const page = parseInt(currentPage) - 1;

                        // set offset based on the page number
                        blogPostsPaginationAjax.settings.offset = (page - 1) * blogPostsPaginationAjax.settings.postsNumber;
                        blogPostsPaginationAjax.getBlogPosts(false);
                    }
                } else {
                    const totalPages = root.querySelector('.blog-posts-pagination__pagination-pages').dataset.totalPages;
                    if (currentPage < totalPages) {
                        const page = parseInt(currentPage) + 1;

                        // set offset based on the page number
                        blogPostsPaginationAjax.settings.offset = (page - 1) * blogPostsPaginationAjax.settings.postsNumber;
                        blogPostsPaginationAjax.getBlogPosts(false);
                    }
                }
            }
        }, owner);
    },
    changePageWithPageNumberButtonHandler: (owner) => {
        listenWhileConnected(root, 'click', (e) => {
            const link = e.target.closest('.blog-posts-pagination__pagination-page-number');

            if (
                link &&
                link.closest('.blog-posts-pagination__pagination-pages') &&
                !link.classList.contains('var_active') // skip if already active
            ) {
                const page = link.getAttribute('data-page');
                blogPostsPaginationAjax.settings.offset = (parseInt(page) - 1) * blogPostsPaginationAjax.settings.postsNumber;
                blogPostsPaginationAjax.getBlogPosts(false);
            }
        }, owner);
    },
    getActivePage: () => {
        const paginationNumbers = root.querySelector('.blog-posts-pagination__pagination-pages .blog-posts-pagination__pagination-page-number.var_active');

        if ( paginationNumbers ) {
            return paginationNumbers.getAttribute('data-page');
        } else {
            return 1;
        }
    },
    categoryChangeHandler: () => {
        const filters = root.querySelectorAll('.blog-posts-pagination__categories li');

        filters.forEach(filter => {
            filter.addEventListener('click', () => {
                if ( blogPostsPaginationAjax.settings.filter === filter.getAttribute('data-id') ) return;
                const lastActiveFilter = root.querySelector('.blog-posts-pagination__categories li.var_active');

                blogPostsPaginationAjax.settings.filter = filter.getAttribute('data-id');
                filter.classList.add('var_active');
                lastActiveFilter.classList.remove('var_active');
                blogPostsPaginationAjax.resetPagination();
                blogPostsPaginationAjax.getBlogPosts();
            })
        })

        blogPostsPaginationAjax.settings.postsNumber = [...root.querySelectorAll('.blog-tile-new')].length;

    },
    resetPagination: () => {
      blogPostsPaginationAjax.settings.offset = 0;
    },
    getBlogPosts: () => {
        const loader = root.querySelector('.loader-container');

        const ajax_data = {
          action: 'blog-posts-pagination',
          filter: blogPostsPaginationAjax.settings.filter,
          postsNumber: blogPostsPaginationAjax.settings.postsNumber,
          offset: blogPostsPaginationAjax.settings.offset
        };

        jQuery.ajax(
          {
            type: 'GET',
            url: ajax.ajax_url,
            data: ajax_data,
            beforeSend() {
              loader.classList.add('var_active');
            },
            success(data) {
              const response = data.data;
              const html = response.html;
              const productsContainer = root.querySelector('.blog-posts-pagination__posts .row');
              const paginationContainer = root.querySelector('.blog-posts-pagination__pagination');

              if ( paginationContainer ) {
                  paginationContainer.innerHTML = response.pagination_html;
              }

              jQuery(productsContainer).html(html);

              // Calculate dynamic offset based on present elements
              const element = root.querySelector('.blog-posts-pagination');

              // Dynamically calculate offset based on which elements are present
              let offsetHeight = 0;
              const topBanner = document.querySelector('.header__top-banner-cta-bar');
              const adminBar = document.querySelector('#wpadminbar');

              if (topBanner) {
                offsetHeight += topBanner.offsetHeight;
              }

              if (adminBar) {
                offsetHeight += adminBar.offsetHeight;
              }

              // Apply the dynamic scroll margin
              element.style.scrollMarginTop = offsetHeight + 'px';
              element.scrollIntoView({behavior: 'smooth'});

              loader.classList.remove('var_active');

              if ( window.location.hash ) {
                // Just in case the above scroll didn't work with the hash
                setTimeout(() => {
                  element.scrollIntoView({behavior: 'smooth'});
                }, 100);
              }
            },
            error(xhr, status, errorThrown) {
              alert('Something went wrong. Please try later. ')
            },
          },
        );
    },
    checkHash: () => {
      const hash = window.location.hash;

      if ( hash ) {
          const clearHash = hash.slice(hash.indexOf('#') + 1);

          const filter = root.querySelector(`.blog-posts-pagination__categories li[data-slug="${clearHash}"]`);
          filter?.click();
      }
  }
  };

  return blogPostsPaginationAjax;
};

bootBlock('blog-posts-pagination', (root) => {
    const section = root.querySelector('.blog-posts-pagination');

    if ( claim(section, 'juniperAjax') ) {
        createBlogPostsPaginationAjax(root).init(section);
    }
});
